module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/surveys/box-view-version/sub-menu/sub-menu-icon.component.less
// module id = ./src/app/routes/surveys/box-view-version/sub-menu/sub-menu-icon.component.less
// module chunks = main